import { useTranslation } from "react-i18next";
import { Flag } from "lucide-react";

export function FeatureFlagsListEmpty() {
  const { t } = useTranslation();
  return (
    <div
      data-testid="feature-flags-list-empty"
      className="rounded-lg border border-dashed border-border bg-muted/20 p-10 text-center"
    >
      <Flag className="mx-auto h-8 w-8 text-muted-foreground" />
      <h2 className="mt-3 font-display text-xl">{t("featureFlags.empty.title")}</h2>
      <p className="mt-1 font-sans text-sm font-normal text-muted-foreground">
        {t("featureFlags.empty.body")}
      </p>
    </div>
  );
}
